import {
  Archive,
  ChartLine,
  CircleArrowUp,
  Clapperboard,
  Download,
  House,
  Inbox,
  Keyboard,
  type LucideIcon,
  MessageSquareHeart,
  Rocket,
  Settings,
  Star,
  User,
} from "lucide-react";

// Same lucide icons as wn-standalone's NavRail (nav-eles.tsx), so a docs page
// shows the exact icon the reader is looking for in the app's icon-only rail.
export const DOC_ICONS = {
  rocket: Rocket,
  user: User,
  house: House,
  inbox: Inbox,
  archive: Archive,
  star: Star,
  "message-square-heart": MessageSquareHeart,
  "chart-line": ChartLine,
  clapperboard: Clapperboard,
  download: Download,
  settings: Settings,
  "circle-arrow-up": CircleArrowUp,
  keyboard: Keyboard,
} satisfies Record<string, LucideIcon>;

export type DocIconName = keyof typeof DOC_ICONS;

export const DOC_ICON_NAMES = Object.keys(DOC_ICONS) as [DocIconName, ...DocIconName[]];
